import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShortCircuitCurrentAnalysisService {

  public isSccaAvailable: boolean = false;
  constructor(
    private httpClient: HttpClient
  ) { }

  getIsSccaAvailable(){
    // console.log("IS it available", this.isSccaAvailable)
    return this.isSccaAvailable;
  }

  getSccaResults(cableId: number){
    return this.httpClient.get(environment.API_BASE_URL + "application/scc/" + cableId);
  }
}
